<div class="wrapper">
  <div *ngIf="loading" class="overlay">
    <mat-spinner class="center" diameter="50"></mat-spinner>
  </div>
  <ng-content></ng-content>
</div>
